import React from 'react'
import { DateRangePicker } from 'react-date-range'

function MovieReleaseDateAndEndDate(props) {
  const {
    openDatePicker,
    showDates,
    statusType,
    getFormattedDate,
    state,
    removeDate,
    handleSelect,
    showDatePicker,
  } = props
  return (
    <div className='datefilter-style'>
      <div className='date1'>
        <div className='startdate d-flex flex-column' style={{ marginRight: '10px' }}>
          <div
            className='d-flex'
            style={{ marginBottom: '10px', gap: '15px', alignItems: 'center' }}
          >
            <div>
              {props.disapperAllFilters ? (
                <div className='d-flex' style={{ gap: '15px' }}>
                  <div className=' p-0'>
                    <label>Release Start Date: </label>
                    <input
                      disabled={statusType === 'draft'}
                      style={{ width: '11rem' }}
                      type='text'
                      onClick={() => {
                        openDatePicker()
                      }}
                      value={showDates ? getFormattedDate(state.startDate) : ''}
                      placeholder='Choose Start Date'
                    ></input>
                  </div>
                  <div className=' p-0'>
                    <label>Release End date: </label>
                    <input
                      disabled={statusType === 'draft'}
                      style={{ width: '11rem' }}
                      type='text'
                      onClick={() => {
                        openDatePicker()
                      }}
                      value={showDates ? getFormattedDate(state.endDate) : ''}
                      placeholder='Choose End Date'
                    ></input>
                  </div>
                  <div className='d-flex align-items-end'>
                    <button
                      style={{ padding: '1px 7px', marginLeft: '4px' }}
                      className='btn btn-primary'
                      onClick={removeDate}
                    >
                      clear
                    </button>
                  </div>
                </div>
              ) : (
                ''
              )}
            </div>
          </div>
          <div></div>
          {showDatePicker ? (
            <DateRangePicker
              onChange={handleSelect}
              showSelectionPreview={true}
              moveRangeOnFirstSelection={false}
              months={1}
              ranges={[state]}
              direction='horizontal'
            />
          ) : null}
        </div>
      </div>
    </div>
  )
}

export default MovieReleaseDateAndEndDate
